import { router } from 'expo-router';

import { shouldShowIOSAppPage } from '../components/start-membership/GetTheApp';

export const continueToNextPage = () => {
    if (shouldShowIOSAppPage()) {
        router.push('/start-membership/get-the-app');
    } else {
        router.push('/home');
    }
};
